module.exports = __webpack_public_path__ + "static/media/borderline.8bc847f5.png";